import React from "react";

const CalendarDetailIcon = (props) => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        {...props}
      >
        <g
          data-name="Icon feather-calendar"
          fill="none"
          stroke="#202d5b"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
        >
          <path
            data-name="Trazado 1317"
            d="M3.266 3.266h15.862a2.266 2.266 0 0 1 2.266 2.266v15.862a2.266 2.266 0 0 1-2.266 2.266H3.266A2.266 2.266 0 0 1 1 21.394V5.532a2.266 2.266 0 0 1 2.266-2.266Z"
          />
          <path data-name="Trazado 1318" d="M15.729 1v4.532" />
          <path data-name="Trazado 1319" d="M6.665 1v4.532" />
          <path data-name="Trazado 1320" d="M1 10.064h20.394" />
        </g>
      </svg>
    </>
  );
};

export default CalendarDetailIcon;
